module.exports = __webpack_public_path__ + "static/media/vtex21.36829b81.png";